import { AuviousRtc, AuviousRtcFactory, IRegisterOptions } from "@auvious/rtc";
import { ErrorCode } from "../models";
import { HandledError } from "../models/HandledError";
import { Log } from "./log.service";
import { AuviousCommon } from "@auvious/common";

class RTCServiceCtrl {
  constructor() {}

  async createInstance(common: AuviousCommon): Promise<AuviousRtc> {
    try {
      const client = AuviousRtcFactory.create();
      await this.register(client, common);
      return client;
    } catch (ex) {
      throw ex;
    }
  }

  public async logout(client: AuviousRtc) {
    if (client?.registered()) {
      try {
        await client.unregister();
      } catch (error) {
        Log.error(error);
      }
    }
  }

  private register(client: AuviousRtc, common: AuviousCommon): Promise<void> {
    return new Promise((resolve, reject) => {
      if (client.registered()) {
        return;
      }
      const options: IRegisterOptions = {
        auviousCommonClient: common,
        serverKeepAliveReminderOn: true,
        eventHandlers: {
          connecting: (_: any) => {},
          connected: (_: any) => {},
          disconnected: (_: any) => {},
          connectionError: (_: any) => {},
          registered: (_: any) => {
            resolve();
          },
          unregistered: (_: any) => {},
          registrationFailed: (event?: any) => {
            reject(new HandledError(event, ErrorCode.RTC_REGISTRATION_ERROR));
          },
          warning: (_: any) => {},
          newMessage: (_: any) => {},
        },
      };

      client.register(options).catch((ex) => {
        reject(new HandledError(ex, ErrorCode.RTC_REGISTRATION_ERROR));
      });
    });
  }
}

export const RTCService = new RTCServiceCtrl();
